import { Clipboard, TouchableOpacity, View } from "react-native";
import { FONT_SIZE } from "../styles";
import React from "react";
import { Typography } from "@mui/material";
import Text from "../../common/component/CustomTextComponent";
import { TooltipV3 } from "../../common/component";
import { FONT_FAMILY, THEME_COLORS } from "../themes";
import { MaterialIcons } from "@expo/vector-icons";

interface ICarDetailProps {
  carObject: {
    make: string;
    model: string;
    variant: string;
    registrationNo: string;
    year: string;
  };
  fontSize?: "small" | "x-small" | "large" | "medium";
  fontFamily?: any;
  style?: any;
  isCopyToClipboardEnabled?: boolean;
}
const CarDetailV3 = (props: ICarDetailProps) => {
  const carObject = props.carObject;
  const fontSize = props.fontSize ?? "small";
  const fontFamily = props.fontFamily;

  return (
    <View style={[{ flexDirection: "column", flexWrap: "wrap" }, props.style]}>
      <View style={{ marginBottom: 0, flexWrap: "wrap" }}>
        <TooltipV3
          title={`${!!carObject?.year ? carObject.year : ""} ${!!carObject?.make ? carObject.make : ""} ${!!carObject?.model ? carObject.model : ""} ${!!carObject?.variant ? carObject.variant : ""}`}
        >
          <Typography
            variant="body1"
            style={{
              fontFamily,
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 1,
              fontSize: "1em",
            }}
          >
            {`${!!carObject?.year ? carObject.year : ""} ${!!carObject?.make ? carObject.make : ""} ${!!carObject?.model ? carObject.model : ""} ${!!carObject?.variant ? carObject.variant : ""}`}
          </Typography>
        </TooltipV3>
        <TouchableOpacity
          onPress={()=>{
            Clipboard.setString(carObject?.registrationNo?.toUpperCase());
          }}
          disabled={!props?.isCopyToClipboardEnabled}
          style={{flexDirection:'row', justifyContent:'space-between', alignItems: 'center'}}
        >
          <Text
            fontSize={fontSize}
            type_of_six={"three_six"}
            style={{ fontFamily: FONT_FAMILY.semiBoldV3, color: THEME_COLORS.textGrey }}
          >
            {carObject?.registrationNo?.toUpperCase()}
          </Text>
          {props?.isCopyToClipboardEnabled && <MaterialIcons name="content-copy" size={16} color={THEME_COLORS.purple} />}
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default CarDetailV3;
